import getWithToken from './base/get-with-token'

const checkSettingUrlFeedBack = (role) => getWithToken(`/check-role-url-feedback?role=${role}`)()

export default checkSettingUrlFeedBack